import { Grid, Loader, Table } from "semantic-ui-react";

import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { MdClose, MdModeEditOutline, MdSave } from "react-icons/md";
import { useGetTransportTypesList } from "../../../../api/static-data";
import { DropDown, InputText, TitleView } from "../../../../components";
import { ENABLE_EXTERNAL_TRANSPORT_TOOL } from "../../../../config/constants";
import { WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../config/optionsConstants";
import { checkValueIsEmpty } from "../../../../utils/utils";
import {
  formatFreightWorkTkm,
  formatRouteLabel
} from "../../UpdateNodes/shared/externalTransport/externalTransport.utils";

import { useUpdateSimulationExternalTransport } from "../../../../api/general/SimulationTransport";
import { InputNumber } from "../../../../components/InputText/InputNumber";
import InputWithDropDown from "../../../../components/inputWithDropDown/InputWithDropDown";
import "./ExternalTransportation.scss";

const ExternalTransport = ({ externalTransport, refetch, isEditable }: any) => {
  const { data: transportationTypesData,  } =
    useGetTransportTypesList();
  const [selectTransport, setSelectTransport] = useState<any>(null);
  const [transportTypeDefault, setDefaultTransportType] = useState<any>(null);
  const [outputUnitTypes, setOutputUnitTypes] = useState<any>(WEIGHT_UNIT_TYPES_OPTIONs[0]);

  const { isLoading: updateExternalLoading, mutate: updateExternalTransport } =
    useUpdateSimulationExternalTransport();

  const externalTransportData = useMemo(() => {
    return externalTransport || [];
  }, [externalTransport]);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm<any>({
    defaultValues: {
      externalTransportData
    }
  });

  const editData = (row: any) => {
    setSelectTransport(row);
    reset({
      externalTransportData: externalTransportData.map((gate: any) => ({
        ...gate
      }))
    });
    setDefaultTransportType(row?.transportationType?.toString());
    setOutputUnitTypes(row?.weightUnit);
  };

  const handleCancel = () => {
    setSelectTransport(null);
    reset();
  };

  const onSubmit = (data: any) => {
    const currentUpdateData = data?.externalTransportData?.find(
      (transport: any) => transport._id === selectTransport._id
    );
    if (currentUpdateData) {
      const { _id, tenantId, ...payloadWithoutId } = currentUpdateData;

      const updatedTransport = {
        id: selectTransport._id,
        data: payloadWithoutId
      };
      updateExternalTransport(updatedTransport, {
        onSuccess(data, variables, context) {
          setSelectTransport(null);
          refetch();
        }
      });
    }
  };

  return (
    <>
      <TitleView CustomTitleViewMain="mt-2" title="External Transportation" />
      <Table celled className="table" structured>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="tableHeader" colSpan="1" textAlign="center">
              External Transportation
            </Table.HeaderCell>
            <Table.HeaderCell
              className="tableHeader"
              colSpan="15"
              textAlign="center"
              style={{ backgroundColor: "#f4c6db", color: "#000" }}
            >
              Input field
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell className="tableHeaderReview">
              External Transportation Name
            </Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Transportation Type</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">From</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">To</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Weight</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Distance (km)</Table.HeaderCell>
            {ENABLE_EXTERNAL_TRANSPORT_TOOL && (
              <>
                <Table.HeaderCell className="tableHeaderReview">Freight work (t·km)</Table.HeaderCell>
                <Table.HeaderCell className="tableHeaderReview">Route</Table.HeaderCell>
                <Table.HeaderCell className="tableHeaderReview">Vehicle</Table.HeaderCell>
              </>
            )}
            <Table.HeaderCell className="tableHeaderReview" />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {externalTransport.map((data: any, index: any) => {
            const currentTranspotationType = data?.transportationType.toString() || 0;
            const transportationType = transportationTypesData?.find(
              (transport: any) => transport.value === currentTranspotationType
            );
            const weightUnit = WEIGHT_UNIT_TYPES_OPTIONs.find(
              (weight: any) => weight.key === data.weightUnit
            );

            const currentSelectTransport = selectTransport?._id === data._id;
            return (
              <Table.Row className="customTransportDropDown">
                <Table.Cell className={checkValueIsEmpty(data.externalTransportName)}>
                  {currentSelectTransport ? (
                    <InputText
                      register={register}
                      errors={errors.internalTransportName}
                      placeholder="Internal Transport Name"
                      name={`externalTransportData.${index}.externalTransportName`}
                      required={true}
                      errorMessage={"Please enter Internal Transport Name"}
                    />
                  ) : (
                    <> {data.externalTransportName || "Missing transport name"}</>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {currentSelectTransport ? (
                    <DropDown
                      required={true}
                      placeholder="Select Transportation Type"
                      upward={true}
                      currentData={transportationTypesData}
                      defaultValue={transportTypeDefault}
                      customGridColumn={"customGridColomnType"}
                      handleChangeState={(e: any, { value }: any) => {
                        setDefaultTransportType(value);
                        setValue(`externalTransportData.${index}.transportationType`, value, {
                          shouldDirty: true,
                          shouldValidate: true
                        });
                      }}
                    />
                  ) : (
                    <> {transportationType?.text}</>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {currentSelectTransport ? (
                    <InputText
                      register={register}
                      errors={errors.from}
                      placeholder="From"
                      name={`externalTransportData.${index}.from`}
                      required={true}
                      errorMessage={"Please enter From"}
                    />
                  ) : (
                    <> {data?.from}</>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {currentSelectTransport ? (
                    <InputText
                      register={register}
                      errors={errors.to}
                      placeholder="To"
                      name={`externalTransportData.${index}.to`}
                      required={true}
                      errorMessage={"Please enter To"}
                    />
                  ) : (
                    <> {data?.to}</>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {currentSelectTransport ? (
                    <InputWithDropDown
                      defaultSelectValue={outputUnitTypes}
                      options={WEIGHT_UNIT_TYPES_OPTIONs}
                      selectOption={(value: string | number) => {
                        setOutputUnitTypes(value);
                        setValue(`externalTransportData.${index}.weightUnit`, value, {
                          shouldDirty: true,
                          shouldValidate: true
                        });
                      }}
                      control={control}
                      placeholder="weight"
                      name={`externalTransportData.${index}.weight`}
                      upward
                      errors={(errors?.externalTransportData as any)?.[index]?.weightUnit}
                      errorMessage="Weight is required"
                      customText="customProcessReviewInput"
                      valueAsNumber={true}
                      required={true}
                      transform={{
                        input: (value: any) =>
                          isNaN(value) || value === 0 ? "" : value.toString(),
                        output: (e: any) => {
                          return e;
                        }
                      }}
                    />
                  ) : (
                    <>
                      {data?.weight} {weightUnit?.text}
                    </>
                  )}
                </Table.Cell>
                <Table.Cell className={checkValueIsEmpty(data?.distance)}>
                  {currentSelectTransport ? (
                    <InputNumber
                      control={control}
                      placeholder="Distance"
                      name={`externalTransportData.${index}.distance`}
                      transform={{
                        input: (v: any) =>
                          v === null || v === undefined || isNaN(v) ? "" : v.toString(),
                        output: (e: any) => e
                      }}
                      errors={(errors?.externalTransportData as any)?.[index]?.distance}
                      required
                      errorMessage="Distance is required"
                    />
                  ) : (
                    <> {data?.distance || 0}</>
                  )}
                </Table.Cell>
                {ENABLE_EXTERNAL_TRANSPORT_TOOL && (
                  <>
                    <Table.Cell>
                      {formatFreightWorkTkm(
                        data?.weight,
                        data?.weightUnit,
                        data?.distance,
                        data?.freightWorkTkm ?? data?.freight_work_tkm
                      )}
                    </Table.Cell>
                    <Table.Cell>{formatRouteLabel(data?.from, data?.to)}</Table.Cell>
                    <Table.Cell>{transportationType?.text || "—"}</Table.Cell>
                  </>
                )}
                <Table.Cell>
                  <Grid>
                    <Grid.Column computer={4} tablet={5} mobile={5}>
                      {updateExternalLoading && currentSelectTransport ? (
                        <Loader active size="small" inline="centered" />
                      ) : currentSelectTransport ? (
                        <MdSave
                          cursor="pointer"
                          size={24}
                          color="var(--tableEditIcon)"
                          title="Save"
                          onClick={handleSubmit(onSubmit)}
                        />
                      ) : (
                        <>
                          {isEditable && (
                            <MdModeEditOutline
                              cursor="pointer"
                              size={24}
                              color="var(--tableEditIcon)"
                              onClick={() => editData(data)}
                            />
                          )}
                        </>
                      )}
                    </Grid.Column>
                    {!updateExternalLoading && currentSelectTransport ? (
                      <Grid.Column computer={4} tablet={16} mobile={16}>
                        <MdClose
                          cursor={"pointer"}
                          size={24}
                          color="var(--tableEditIcon)"
                          onClick={handleCancel}
                        />
                      </Grid.Column>
                    ) : null}
                  </Grid>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
};

export default ExternalTransport;
